import React, { useState } from 'react';
import { Modal, Tag, Table } from "antd";
import { useTeamCandidateScope } from "./TeamCandidateScopeProvider";
import Form, { FormInputComponent } from "../../../components/form/Form";
import UserImageCircle from '../../../components/UserImageCircle';
import Opportunity from '../../../models/Opportunity';

const TeamMemberContactForm = ({ talentOpp, onClose, ...props }) => {

    const {
        team,
        isDisabled,
        isLoading,
        onContactTeamMember
    } = useTeamCandidateScope();

    const [formModel, setFormModel] = useState({
        message_to_talent: ''
    });
    if (isLoading|| !team) {
        return null
    }
    return (
        <Modal
            okText="Submit"
            title="Message to Talent"
            className="project-scope-modal"
            open={!!talentOpp}
            closeable={true}
            centered
            maskClosable={true}
            style={{ top: 20 }}
            destroyOnClose={true}
            okButtonProps={{ disabled: isDisabled }}
            width={1000}
            confirmLoading={isDisabled}
            onCancel={onClose}
            onOk={async () => {
                // wait for success response then fire onClose

                const response = await onContactTeamMember({ ...formModel, talent_user_id: talentOpp?.user?.id });

                if (response) {
                    return onClose()
                }
            }}
        >
            {!!talentOpp && (
                <div className="project-scope-form">

                    <div className="pb-4">
                        Compose your message below to send to <strong>{talentOpp.user?.fullName()}</strong>. Your message will be delivered via email to both you and the talent.
                    </div>

                    <div className="">
                        <Table pagination={false} dataSource={[talentOpp]} className="manage-scope-table team-member-opp-status-table">
                            <Table.Column
                                title="Member"
                                dataIndex="user"
                                key="user"
                                render={(user, opp) => (
                                    <div key={user.id} className="flex flex-row items-center gap-1.5">
                                        <UserImageCircle user={user} size={32} />
                                        <p className="font-semibold text-xs">
                                            {user.fullName()}
                                        </p>
                                    </div>
                                )}
                            />
                            <Table.Column
                                title="Roles"
                                dataIndex="disciplines"
                                key="disciplines"
                                render={(disciplines, opp) => (
                                    <div className="flex flex-col items-start gap-2">
                                        {disciplines.map((discipline) => (
                                            <div key={discipline.id} className="h-4 flex flex-row items-center justify-start gap-1.5">
                                                <Tag color={opp.status === Opportunity.Statuses.Lost ? undefined : "purple"}>
                                                    {discipline.name}
                                                </Tag>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            />
                            <Table.Column
                                title="Hours"
                                dataIndex="disciplines"
                                key="disciplines"
                                render={(disciplines, opp) => (
                                    <div className="flex flex-col items-start gap-2">
                                        {TB.map(disciplines, discipline => {
                                            return (
                                                <div key={discipline.id}
                                                    className="h-4 flex flex-row items-center justify-start gap-1.5">
                                                    <p className="text-sm whitespace-nowrap">
                                                        <i className={TB.mapClass("fas", {
                                                            "fa-times-circle text-danger": opp.rejected_at || opp.withdrew_at,
                                                            "fa-clock text-gray-300": discipline.matches_total_periods && !opp.accepted_at && !opp.rejected_at && !opp.withdrew_at,
                                                            "fa-check-circle text-success": !(opp.rejected_at || opp.withdrew_at) && discipline.matches_total_periods && opp.accepted_at,
                                                            "fa-exclamation-triangle text-warning": !(opp.rejected_at || opp.withdrew_at) && !discipline.matches_total_periods
                                                        })} />
                                                    </p>
                                                    {!discipline.matches_total_periods && (
                                                        <p className="text-sm line-through text-black whitespace-nowrap">
                                                            <span className="text-danger">
                                                                {discipline.total_hours} Hrs
                                                            </span>
                                                        </p>
                                                    )}
                                                    <p className="text-sm font-medium whitespace-nowrap">
                                                        {discipline.proposed_total_periods || discipline.total_hours} Hrs
                                                    </p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                            />
                            <Table.Column
                                title="Talent Rate"
                                dataIndex="disciplines"
                                key="disciplines"
                                render={(disciplines, opp) => (
                                    <div className="flex flex-col items-start gap-2">
                                        {TB.map(disciplines, discipline => {
                                            return (
                                                <div key={discipline.id}
                                                    className="h-4 flex flex-row items-center justify-start gap-1.5">
                                                    <p className="text-sm whitespace-nowrap">
                                                        <i className={TB.mapClass("fas", {
                                                            "fa-times-circle text-danger": opp.rejected_at || opp.withdrew_at,
                                                            "fa-clock text-gray-300": !(opp.rejected_at || opp.withdrew_at) && discipline.matches_hourly_rate && !opp.accepted_at,
                                                            "fa-check-circle text-success": !(opp.rejected_at || opp.withdrew_at) && discipline.matches_hourly_rate && opp.accepted_at,
                                                            "fa-exclamation-triangle text-warning": !(opp.rejected_at || opp.withdrew_at) && !discipline.matches_hourly_rate
                                                        })} />
                                                    </p>
                                                    {!discipline.matches_hourly_rate && (
                                                        <p className="text-sm line-through text-black whitespace-nowrap">
                                                            <span className="text-danger">
                                                                {TB.formatCurrency(discipline.hourly_rate)}/hr
                                                            </span>
                                                        </p>
                                                    )}

                                                    <p className="text-sm font-medium whitespace-nowrap">
                                                        {TB.formatCurrency(discipline.proposed_hourly_rate || discipline.hourly_rate)}/hr
                                                    </p>

                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                            />
                            <Table.Column
                                title="Talent Payout"
                                dataIndex="disciplines"
                                key="disciplines"
                                render={(disciplines, opp) => {
                                    const hasProposedPayout = TB.find(disciplines, ['matches_payout', false]);
                                    const estimatedPayout = TB.sumBy(disciplines, 'payout_amount')
                                    const proposedPayout = TB.sumBy(disciplines, discipline => discipline.proposed_payout_amount || discipline.payout_amount)

                                    return (
                                        <div className="flex flex-col items-start gap-2">

                                            <div className="h-4 flex flex-row items-center justify-start gap-1.5">
                                                <p className="text-sm whitespace-nowrap">
                                                    <i className={TB.mapClass("fas", {
                                                        "fa-times-circle text-danger": opp.rejected_at || opp.withdrew_at,
                                                        "fa-clock text-gray-300": !(opp.rejected_at || opp.withdrew_at) && !hasProposedPayout && !opp.accepted_at,
                                                        "fa-check-circle text-success": !(opp.rejected_at || opp.withdrew_at) && !hasProposedPayout && opp.accepted_at,
                                                        "fa-exclamation-triangle text-warning": !(opp.rejected_at || opp.withdrew_at) && hasProposedPayout
                                                    })} />
                                                </p>
                                                {hasProposedPayout && (
                                                    <p className="text-sm whitespace-nowrap line-through text-black">
                                                        <span className="text-danger">
                                                            {TB.formatCurrency(estimatedPayout, false)}
                                                        </span>
                                                    </p>
                                                )}

                                                <p className="text-sm whitespace-nowrap font-medium">
                                                    {TB.formatCurrency(hasProposedPayout ? proposedPayout : estimatedPayout, false)}
                                                </p>
                                            </div>
                                        </div>
                                    )
                                }}
                            />
                        </Table>
                    </div>
                    <Form
                        onSubmit={null}
                        model={formModel}
                        onChange={model => setFormModel({ ...formModel, ...model })}
                        minimal
                        submitButton={false}
                        background={"none"}
                        isDisabled={isDisabled}
                        fields={[]}
                    >
                        <FormInputComponent
                            fieldName="message_to_talent"
                            value={formModel.message_to_talent || ''}
                            disabled={isDisabled}
                            rows={6}
                            // label={"Message To Talent"}
                            label={false}
                            maxLength={2000}
                            required={true}
                            placeholder=""
                            type="lexical-editor"
                            tools={['bold', 'italic', 'underline', 'link', 'ol', 'ul']}
                        />

                    </Form>
                </div>
            )}

        </Modal>
    );
}

export default TeamMemberContactForm;